import request from './request'

export function getPackages(hospId) {
    return request.get('/api/package/list', {
        params: {
            hospId: hospId
        }
    })
}

export function getPackageDetail(hospId, packageId) {
    return request.get('/api/package/find', {
        params: {
            hospid: hospId,
            id: packageId
        }
    });
}

export function getExamTypes(hospId) {
    return request.get('api/package/getExamTypes', {
        params: {
            hospId
        }
    });
}

export function getRecommandPackages(hospId) {
    return request.get('/api/package/recommand', {
        params: {
            hospId: hospId,
            topNumber: 10 //显示10个推荐套餐
        }
    })
}